module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray@3x-9c0cbb6bf0061a101d3dfbf5e336c3b0.png";